
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin } from '@/mixins';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';

@Component
export default class NextEventCard extends Mixins(BAIconsMixin) {
	@Prop({ default: () => [] }) events: CalendarEventModel[];

	get NextEvent(): CalendarEventModel | null {
		const now = new Date();
		const upcoming = (this.events || [])
			.filter(e => e && e.start && new Date(e.start) >= now)
			.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
		return upcoming.length ? upcoming[0] : null;
	}

	get Title(): string {
		if (!this.NextEvent) return '';
		return this.NextEvent.name || this.NextEvent.EventName || 'Event';
	}
	get TimeLabel(): string {
		if (!this.NextEvent) return '';
		if ((this.NextEvent as any).isAllDay) return 'All day';
		const s = new Date(this.NextEvent.start);
		return s.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
	}
	get RelativeLabel(): string {
		if (!this.NextEvent) return '';
		const d = new Date(this.NextEvent.start);
		const today = new Date(); today.setHours(0, 0, 0, 0);
		const day = new Date(d); day.setHours(0, 0, 0, 0);
		const diffDays = Math.round((day.getTime() - today.getTime()) / 86400000);
		if (diffDays === 0) return 'Today';
		if (diffDays === 1) return 'Tomorrow';
		return d.toLocaleDateString([], { weekday: 'long', month: 'short', day: 'numeric' });
	}
	get Counts(): { going: number; maybe: number; no: number } {
		const p = this.NextEvent ? (this.NextEvent.participants || []) : [];
		return {
			going: p.filter(x => x.rsvp === 'Yes').length,
			maybe: p.filter(x => x.rsvp === 'Maybe').length,
			no: p.filter(x => x.rsvp === 'No').length,
		};
	}

	goToEvent(): void {
		if (this.NextEvent) this.$emit('click:event', { calendarEvent: this.NextEvent, $event: null });
	}
}
